module.exports = __webpack_public_path__ + "static/media/next-page.23f6ea48.svg";